import { Box, Checkbox, FormControl, Text, Tooltip, VStack } from "@chakra-ui/react";
import { entityProfileModalColors } from "../../../../../entityProfileModal/entityProfileModal.theme";
import type { PatientProfilePatient } from "../../../../patientProfileModal.types";
import type { PatientAddress } from "../addresses.types";
import { formatPhoneNumberLabel, getPhoneNumberDisplay } from "../addresses.utils";

export function AddressPhoneControl(props: {
  patient: PatientProfilePatient;
  value: PatientAddress["phoneNumberIds"];
  onChange: (value: PatientAddress["phoneNumberIds"]) => void;
}) {
  return (
    <FormControl>
      <PhoneNumberChecklist patient={props.patient} value={props.value} onChange={props.onChange} />
    </FormControl>
  );
}

export function PhoneNumberList(props: {
  patient: PatientProfilePatient;
  phoneNumberIds: PatientAddress["phoneNumberIds"];
}) {
  if (props.phoneNumberIds.length === 0) {
    return (
      <Text as="em" color={entityProfileModalColors.muted}>
        None
      </Text>
    );
  }

  return (
    <VStack alignItems="stretch" spacing={1}>
      {props.phoneNumberIds.map((phoneNumberId) => {
        const phoneNumber = props.patient.phoneNumbers.find((item) => item.id === phoneNumberId);

        if (phoneNumber === undefined) {
          return (
            <Text key={phoneNumberId} color={entityProfileModalColors.muted}>
              Phone #{phoneNumberId}
            </Text>
          );
        }

        return (
          <Tooltip
            key={phoneNumberId}
            hasArrow
            label={phoneNumber.description ?? formatPhoneNumberLabel(phoneNumber)}
          >
            <Text>
              <Box as="span" fontWeight={700}>
                {formatPhoneNumberLabel(phoneNumber)}:
              </Box>{" "}
              {getPhoneNumberDisplay(phoneNumber)}
            </Text>
          </Tooltip>
        );
      })}
    </VStack>
  );
}

function PhoneNumberChecklist(props: {
  isDisabled?: boolean;
  patient: PatientProfilePatient;
  value: PatientAddress["phoneNumberIds"];
  onChange: (value: PatientAddress["phoneNumberIds"]) => void;
}) {
  const hasPhoneNumbers = props.patient.phoneNumbers.length > 0;

  return (
    <VStack alignItems="stretch" spacing={1}>
      {props.patient.phoneNumbers.map((phoneNumber) => {
        const checked = props.value.includes(phoneNumber.id);

        return (
          <Checkbox
            key={phoneNumber.id}
            isChecked={checked}
            isDisabled={props.isDisabled}
            size="sm"
            onChange={() =>
              props.onChange(
                checked
                  ? props.value.filter((phoneNumberId) => phoneNumberId !== phoneNumber.id)
                  : [...props.value, phoneNumber.id]
              )
            }
          >
            <Tooltip
              hasArrow
              label={phoneNumber.description ?? formatPhoneNumberLabel(phoneNumber)}
            >
              <Box as="span">
                <Box as="span" fontWeight={700}>
                  {formatPhoneNumberLabel(phoneNumber)}:
                </Box>{" "}
                {getPhoneNumberDisplay(phoneNumber)}
              </Box>
            </Tooltip>
          </Checkbox>
        );
      })}
      {!hasPhoneNumbers ? (
        <Text as="em" color={entityProfileModalColors.muted}>
          None
        </Text>
      ) : null}
    </VStack>
  );
}
